import React, {useRef} from 'react';
import BackLink from "../../components/BackLink";
import {PDFViewer} from "@react-pdf/renderer";
import BoardingPassPdf from "../../components/pdf/BoardingPassPdf";
import { Trans, useLingui } from '@lingui/react/macro';
import { getBackToDashboardText } from '../../utils/themeUtils';
import { Navigate, useLocation } from 'react-router';

function BoardingPassDetail(props) {
    const pdfRef = useRef(null);

    const handlePrint = () => {
        try {
            pdfRef.current.contentWindow.print();
        } catch (e) {
            // the frame isn't showing the PDF (e.g. Chrome set to download PDFs), so open it directly
            window.open(pdfRef.current.src, "_blank");
        }
    }

    const {state} = useLocation();
    const {t} = useLingui();

    // the data only arrives through the "View" link, so a bookmark or a new tab has none
    if (!state?.passengers) {
        return <Navigate to={t({id: "/boarding"})} replace />;
    }

    const {passengers, bookingData} = state;

    return (
        <div className="container mx-auto mt-4">
            <BackLink to="/" text={getBackToDashboardText()}/>

            <h1><Trans id="boarding_pass">Boarding pass</Trans></h1>

            <div className="mt-4">
                <button className="action-button action-button-enabled w-mobile" onClick={handlePrint}>
                    <Trans id="print_boarding_pass">Print boarding pass</Trans>
                </button>
            </div>

            <div className="w-full container-a4 mt-6 mb-8">
                <div className="container-a4-content">
                    <PDFViewer innerRef={pdfRef} style={{width: "100%", height: "100%"}}>
                        <BoardingPassPdf passengers={passengers} bookingData={bookingData}/>
                    </PDFViewer>
                </div>
            </div>
        </div>
    );
}

export default BoardingPassDetail;